<template>
  <button
    aria-label="Toggle with media"
    class="justify-between items-center rounded-full border border-gray-light hover:border-black text-left text-sm h-9 pl-4"
    @click="toggleMedia"
  >
    <span>With media</span>
    <span
      class="bg-success relative rounded-full p-2 w-1 h-1 mr-3 border border-gray-light"
      :class="{ 'bg-white': !withMedia }"
    >
      <img src="/images/checkmarkThick.svg" class="w-2 absolute m-auto inset-0" width="8" height="8" alt="checkmark" />
    </span>
  </button>
</template>

<script setup lang="ts">
const { withMedia } = defineProps<{
  withMedia: boolean
}>()

const emit = defineEmits(['onMediaChange'])

function toggleMedia() {
  emit('onMediaChange', !withMedia)
}
</script>
